const language = "CN"

export default language